'use client';

import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useGameStore } from '@/store/useGameStore';

export function XPToast() {
  const notifications = useGameStore((s) => s.xpNotifications);
  const dismiss = useGameStore((s) => s.dismissXPNotification);

  return (
    <div
      className="fixed bottom-6 right-6 z-[9999] flex flex-col gap-2"
      aria-live="polite"
    >
      {notifications.map((notif) => (
        <XPToastItem key={notif.id} id={notif.id} amount={notif.amount} reason={notif.reason} onDismiss={dismiss} />
      ))}
    </div>
  );
}

interface ItemProps {
  id: string;
  amount: number;
  reason: string;
  onDismiss: (id: string) => void;
}

function XPToastItem({ id, amount, reason, onDismiss }: ItemProps) {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(id), 2500);
    return () => clearTimeout(timer);
  }, [id, onDismiss]);

  return (
    <div
      className="xp-toast-enter flex items-center gap-3 rounded-xl px-4 py-3 min-w-[240px] max-w-[320px]"
      style={{
        background: 'var(--color-surface-raised)',
        borderLeft: '4px solid var(--color-secondary)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      }}
      role="status"
    >
      <span className="text-xl">⚡</span>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm" style={{ color: 'var(--color-secondary)' }}>
          +{amount} XP
        </p>
        <p className="text-xs truncate" style={{ color: 'var(--color-text-secondary)' }}>
          {reason}
        </p>
      </div>
      <button
        onClick={() => onDismiss(id)}
        className="flex-shrink-0 p-1 rounded transition-colors"
        style={{ color: 'var(--color-text-muted)' }}
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  );
}
